var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import styled from 'styled-components';
var Footer = styled.footer(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", ";\n"], ["\n  ",
    ";\n"])), function (props) {
    var theme = props.theme;
    return "\n      align-items: center;\n      color: " + (theme === null || theme === void 0 ? void 0 : theme.color.background.foreground) + ";\n      display: flex;\n      flex-direction: row;\n      font-family: " + (theme === null || theme === void 0 ? void 0 : theme.font.primary.family) + ";\n      font-size: " + (theme === null || theme === void 0 ? void 0 : theme.font.primary.size.smallTEMP) + ";\n      height: " + (theme === null || theme === void 0 ? void 0 : theme.size.spacer.xl) + ";\n      justify-content: center;\n      text-align: center;\n\n      a {\n        font-weight: " + (theme === null || theme === void 0 ? void 0 : theme.font.primary.weight.bold) + ";\n        margin-left: " + (theme === null || theme === void 0 ? void 0 : theme.size.spacer.xs) + ";\n      }\n\n      a:link,\n      a:visited {\n        color: " + (theme === null || theme === void 0 ? void 0 : theme.color.background.foreground) + ";\n        text-decoration: none;\n      }\n\n      a:hover {\n        color: " + (theme === null || theme === void 0 ? void 0 : theme.color.primary.background) + ";\n        text-decoration: underline;\n      }\n\n      @media only screen and (max-width: 700px) {\n        flex-direction: column;\n      }\n    ";
});
export function SAFooter(_a) {
    var removeBranding = _a.removeBranding, rest = __rest(_a, ["removeBranding"]);
    var branding = removeBranding === true ? 'Company' : 'State Automobile Mutual Insurance Company';
    var today = new Date();
    var year = today.getFullYear().toString();
    var text = "\u00A9 " + year + " Copyright " + branding + ". All rights reserved.";
    var links = !removeBranding ? (React.createElement(React.Fragment, null,
        React.createElement("a", { href: "https://www.stateauto.com/privacy" }, "Privacy Policy."),
        React.createElement("a", { href: "https://www.stateauto.com/terms" }, "Terms of Use."))) : ('');
    return (React.createElement(Footer, __assign({}, rest),
        text,
        React.createElement("span", null, links)));
}
SAFooter.defaultProps = {
    removePadding: false,
};
var templateObject_1;
//# sourceMappingURL=footer.component.js.map